import { gql } from '@apollo/client';

export const GET_COHORT_INSTITUTIONS_FROM_IDS = gql`
  query GetCohortInstitutionsFromIds($input: CohortInstitutionsInput!) {
    institutions: getCohortInstitutionsFromIds(input: $input) {
      id
      name
    }
  }
`;
